import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import MembershipBenefits from './components/MembershipBenefits';
import RequirementsSection from './components/RequirementsSection';
import DayInLifeSection from './components/DayInLifeSection';
import ApplicationForm from './components/ApplicationForm';
import MeetingInfo from './components/MeetingInfo';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from '../about-heritage-vision/components/FAQSection';
import Footer from 'components/ui/Footer';

const JoinMembershipGateway = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="pt-16">
        <HeroSection />
        <MembershipBenefits />
        <RequirementsSection />
        <DayInLifeSection />
        {/* <TestimonialsSection /> */}
        {/* <ApplicationForm /> */}
        {/* <MeetingInfo /> */}
        {/* <FAQSection /> */}
      </main>
      <Footer />
    </div>
  );
};

export default JoinMembershipGateway;